import reveal from './Modules/reveal.js';
import kvScene from './Modules/kvScene.js';
import actionScene from './Modules/actionScene.js';


const preinit = () => {

}

const init = () => {
  // 先に監視を張る。actionScene は __scene の observe:visible を待つ
  reveal.init();
  actionScene.init();
  // KVはスクロール監視を使わず、画像が揃った時点で自分で再生する
  kvScene.init();
}

const resize = () => {

}

const resizeW = () => {

}

const scroll = () => {

}

const load = () => {

}

export {
  preinit,
  init,
  resize,
  resizeW,
  scroll,
  load
}
